module.exports = __webpack_public_path__ + "static/media/obi.c4cdc050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/obi.jpg
// module id = 37
// module chunks = 0